import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { usePrefs } from 'wsm-common-data';
import { setNewRelicCustomAttribute } from 'ddc-new-relic';
import HighlightedFeatures from '../components/HighlightedFeatures';
import AllHighlightedFeatures from '../components/AllHighlightedFeatures';

const Widget = () => {
	const prefs = usePrefs();
	const [isFullWidthLayout, setIsFullWidthLayout] = useState(false);
	const features = useSelector((state) => state.features);
	const windowId = useSelector((state) => state.requestData.windowId);
	const { maxHighlightedFeatures } = prefs;

	useEffect(() => {
		setNewRelicCustomAttribute('ws-hl-features-feature-count', features?.length);

		const widgetAppId = `${windowId}-app-root`;
		const hlFeaturesContainer = document.getElementById(widgetAppId);

		if (hlFeaturesContainer?.clientWidth >= 992) {
			setIsFullWidthLayout(true);
		}
	}, [features, windowId]);

	const featureCount = features?.length || 0;
	const isSliceFeatures = featureCount > maxHighlightedFeatures;
	const slicedFeatureArray = isSliceFeatures 
		? features.slice(0, maxHighlightedFeatures)
		: features;

	return (
		<>
			<HighlightedFeatures
				features={slicedFeatureArray}
				isFullWidthLayout={isFullWidthLayout}
			/>
			{isSliceFeatures && <AllHighlightedFeatures />}
		</>
	);
};

export default Widget;
